import { generateApiRoute } from '@klp/core/api/helpers';

import { baseApi } from '@klp/core/api';
import {
    configApiName,
    confluenceContentApiName,
    confluenceSummaryApiName,
    forvaltningsplanApiName,
} from '../config';

export type ConfluenceContent = {
    id?: string;
    body?: string;
    styling?: string;
    readLink?: string;
    editLink?: string;
};

export const forvaltningsplanApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getConfluenceLink: build.query<
            string,
            { byggNummer: string; aar?: number }
        >({
            query: ({ byggNummer, aar }) => ({
                url: generateApiRoute([
                    configApiName,
                    forvaltningsplanApiName,
                    byggNummer,
                ]),
                params: { aar },
                method: 'GET',
                headers: { 'Content-Type': 'text/plain' },
                responseHandler: (response) => response.text(),
            }),
            providesTags: ['Config'],
        }),
        getConfluenceContent: build.query<
            ConfluenceContent,
            { byggNummer: string; aar: number }
        >({
            query: ({ byggNummer, aar }) => ({
                url: generateApiRoute([
                    configApiName,
                    forvaltningsplanApiName,
                    confluenceContentApiName,
                    byggNummer,
                    aar,
                ]),
                method: 'GET',
            }),
            providesTags: ['Config'],
        }),
        getConfluenceSummary: build.query<
            ConfluenceContent,
            { byggNummer: string; aar: number }
        >({
            query: ({ byggNummer, aar }) => ({
                url: generateApiRoute([
                    configApiName,
                    forvaltningsplanApiName,
                    confluenceSummaryApiName,
                    byggNummer,
                    aar,
                ]),
                method: 'GET',
            }),
            providesTags: ['Config'],
        }),
    }),
});

export const {
    useLazyGetConfluenceLinkQuery,
    useGetConfluenceLinkQuery,
    useGetConfluenceContentQuery,
    useLazyGetConfluenceContentQuery,
    useGetConfluenceSummaryQuery,
    useLazyGetConfluenceSummaryQuery,
} = forvaltningsplanApi;
